import types from "./types"

const initState = {
    oneClickPrescribeQueueLoading: false,
    oneClickPrescribeQueue: {},
    oneClickPrescribeQueueCount: null,
    successfulCaseIds: [], // Track cases marked as successful for animation
};

export default function oneClickPrescribeQueue(
    state = initState,
    action,
) {
    switch (action.type) {
        case types.SET_ONE_CLICK_PRESCRIBE_QUEUE_LOADING:
            return {
                ...state,
                oneClickPrescribeQueueLoading: action.data,
            };
        case types.SET_ONE_CLICK_PRESCRIBE_QUEUE:
            return {
                ...state,
                oneClickPrescribeQueue: action.data || {},
                oneClickPrescribeQueueCount: Object.values(action.data).reduce((acc, category) => acc + category.total, 0)
            }
        case types.REMOVE_ONE_CLICK_PRESCRIBE_CASE_FROM_QUEUE:
            // Remove case from the appropriate category
            const updatedQueue = { ...state.oneClickPrescribeQueue };
            
            // Find and remove the case from its category
            Object.keys(updatedQueue).forEach(categoryId => {
                const category = updatedQueue[categoryId];
                if (category && category.cases) {
                    const filteredCases = category.cases.filter(_case => _case._id !== action.data);
                    if (filteredCases.length !== category.cases.length) {
                        updatedQueue[categoryId] = {
                            ...category,
                            cases: filteredCases,
                            total: Math.max(0, (category.total || 0) - 1)
                        };
                    }
                }
            });
            
            // Also remove from successfulCaseIds
            const filteredSuccessfulIds = state.successfulCaseIds.filter(id => id !== action.data);
            
            return {
                ...state,
                oneClickPrescribeQueue: updatedQueue,
                oneClickPrescribeQueueCount: Object.values(updatedQueue).reduce((acc, category) => acc + category.total, 0),
                successfulCaseIds: filteredSuccessfulIds
            }
        case types.ADD_CASE_TO_ONE_CLICK_PRESCRIBE_QUEUE:
            const _case = action.data;
            const categoryId = _case.categoryId;
            
            if (!categoryId) return state;
            
            const updatedQueueWithNewCase = { ...state.oneClickPrescribeQueue };
            
            if (updatedQueueWithNewCase[categoryId]) {
                updatedQueueWithNewCase[categoryId] = {
                    ...updatedQueueWithNewCase[categoryId],
                    cases: [...updatedQueueWithNewCase[categoryId].cases, _case],
                    total: (updatedQueueWithNewCase[categoryId].total || 0) + 1
                };
            } else {
                updatedQueueWithNewCase[categoryId] = {
                    cases: [_case],
                    total: 1
                };
            }

            return {
                ...state,
                oneClickPrescribeQueue: updatedQueueWithNewCase,
                oneClickPrescribeQueueCount: Object.values(updatedQueueWithNewCase).reduce((acc, category) => acc + category.total, 0)
            }
        case types.MARK_ONE_CLICK_PRESCRIBE_CASE_SUCCESSFUL:
            // Add case ID to successful list if not already there
            const caseId = action.data;
            if (state.successfulCaseIds.includes(caseId)) {
                return state;
            }
            return {
                ...state,
                successfulCaseIds: [...state.successfulCaseIds, caseId]
            }
        case types.ACKNOWLEDGE_FLAGGED_CASE:
            // Add 'acknowledged' tag to the case without removing it from queue
            const acknowledgedCaseId = action.data;
            const queueWithAcknowledged = { ...state.oneClickPrescribeQueue };
            
            // Find the case and add 'acknowledged' tag
            Object.keys(queueWithAcknowledged).forEach(categoryId => {
                const category = queueWithAcknowledged[categoryId];
                if (category && category.cases) {
                    const caseIndex = category.cases.findIndex(_case => _case._id === acknowledgedCaseId);
                    if (caseIndex !== -1) {
                        const updatedCase = { ...category.cases[caseIndex] };
                        updatedCase.tags = [...(updatedCase.tags || []), 'acknowledged'];
                        queueWithAcknowledged[categoryId] = {
                            ...category,
                            cases: [
                                ...category.cases.slice(0, caseIndex),
                                updatedCase,
                                ...category.cases.slice(caseIndex + 1)
                            ]
                        };
                    }
                }
            });
            
            return {
                ...state,
                oneClickPrescribeQueue: queueWithAcknowledged
            }
        default:
            return state;
    }
}

